module.exports = __webpack_public_path__ + "static/media/mobile-wallet.8240b1ca.svg";